<template>
  <footer class="ct-footer">
    <div
      class="ct-footer-top"
      :style="{ backgroundColor: $root.color_schema.footer_bg }"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-12">
            <nav
              class="menu-col footer-mnu"
              v-if="footerComponent.footerMenuTitle1"
            >
              <div class="menu-header" @click="expandFooterMenu(0)">
                <span
                  v-if="footerComponent.footerMenuTitle1"
                  :class="{
                    'custom-font-1 span-h4': true,
                    'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                    'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                  }"
                >
                  {{ footerComponent.footerMenuTitle1 }}
                </span>
                <img
                  :class="{
                    'arrow-img img-rotate': true,
                    'grayscale-invert': getContrastYIQ(
                      $root.color_schema.footer_bg
                    ),
                  }"
                  id="footer-icon-0"
                  width="15"
                  height="10"
                  :src="
                    $root.site_url +
                    $root.asset_path +
                    '/svg-icons/footer-arrow.svg'
                  "
                  alt="Arrow Icon"
                />
              </div>
              <ul class="footer-menu two-columns" id="footer-content-0">
                <template
                  v-if="
                    footerComponent.footerMenu1 &&
                    footerComponent.footerMenu1.length > 0
                  "
                >
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-for="data in footerComponent.footerMenu1.slice(
                      0,
                      footerComponent.footerMenuOffset1
                    )"
                    :key="data.ID"
                  >
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <a
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :href="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</a
                      >
                    </template>
                    <template v-else>
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <router-link
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :to="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</router-link
                      >
                    </template>
                  </li>
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-if="
                      footerComponent.footerMenu1.length >
                      footerComponent.footerMenuOffset1
                    "
                  >
                    <a
                      :title="`footer menu`"
                      :href="footerComponent.footerMenuLink1"
                      >{{ footerComponent.footerMenuText1 }}</a
                    >
                  </li>
                </template>
              </ul>
            </nav>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <nav
              class="menu-col footer-mnu"
              v-if="footerComponent.footerMenuTitle2"
            >
              <div class="menu-header" @click="expandFooterMenu(1)">
                <span
                  v-if="footerComponent.footerMenuTitle2"
                  :class="{
                    'custom-font-1 span-h4': true,
                    'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                    'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                  }"
                >
                  {{ footerComponent.footerMenuTitle2 }}
                </span>
                <img
                  :class="{
                    'arrow-img img-rotate': true,
                    'grayscale-invert': getContrastYIQ(
                      $root.color_schema.footer_bg
                    ),
                  }"
                  width="15"
                  height="10"
                  id="footer-icon-1"
                  :src="
                    $root.site_url +
                    $root.asset_path +
                    '/svg-icons/footer-arrow.svg'
                  "
                  alt="Arrow Icon"
                />
              </div>
              <ul class="footer-menu" id="footer-content-1">
                <template
                  v-if="
                    footerComponent.footerMenu2 &&
                    footerComponent.footerMenu2.length > 0
                  "
                >
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-for="data in footerComponent.footerMenu2.slice(
                      0,
                      footerComponent.footerMenuOffset2
                    )"
                    :key="data.ID"
                  >
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <a
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :href="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</a
                      >
                    </template>
                    <template v-else>
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <router-link
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :to="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</router-link
                      >
                    </template>
                  </li>
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-if="
                      footerComponent.footerMenu2.length >
                      footerComponent.footerMenuOffset2
                    "
                  >
                    <a
                      :title="`footer menu 2`"
                      :href="footerComponent.footerMenuLink2"
                      >{{ footerComponent.footerMenuText2 }}</a
                    >
                  </li>
                </template>
              </ul>
            </nav>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <nav
              class="menu-col footer-mnu"
              v-if="footerComponent.footerMenuTitle3"
            >
              <div class="menu-header" @click="expandFooterMenu(2)">
                <span
                  v-if="footerComponent.footerMenuTitle3"
                  :class="{
                    'custom-font-1 span-h4': true,
                    'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                    'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                  }"
                >
                  {{ footerComponent.footerMenuTitle3 }}
                </span>
                <img
                  :class="{
                    'arrow-img img-rotate': true,
                    'grayscale-invert': getContrastYIQ(
                      $root.color_schema.footer_bg
                    ),
                  }"
                  width="15"
                  height="10"
                  id="footer-icon-2"
                  :src="
                    $root.site_url +
                    $root.asset_path +
                    '/svg-icons/footer-arrow.svg'
                  "
                  alt="Arrow Icon"
                />
              </div>
              <ul class="footer-menu" id="footer-content-2">
                <template
                  v-if="
                    footerComponent.footerMenu3 &&
                    footerComponent.footerMenu3.length > 0
                  "
                >
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-for="data in footerComponent.footerMenu3.slice(
                      0,
                      footerComponent.footerMenuOffset3
                    )"
                    :key="data.ID"
                  >
                    <template v-if="$root.enable_piwik_reload">
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <a
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :href="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</a
                      >
                    </template>
                    <template v-else>
                      <a
                        :title="data.title"
                        v-if="data.object === 'custom'"
                        :href="data.url"
                        >{{ data.title }}</a
                      >
                      <router-link
                        class="cat-cls"
                        :title="data.title"
                        v-else
                        :to="getRouteLink(data.slug, data.object)"
                        >{{ data.title }}</router-link
                      >
                    </template>
                  </li>
                  <li
                    :class="{
                      'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                      'text-light': !getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    v-if="
                      footerComponent.footerMenu3.length >
                      footerComponent.footerMenuOffset3
                    "
                  >
                    <a
                      :title="`footer menu 2`"
                      :href="footerComponent.footerMenuLink3"
                      >{{ footerComponent.footerMenuText3 }}</a
                    >
                  </li>
                </template>
              </ul>
            </nav>
          </div>
          <div
            :class="{
              'overlap-width': true,
              'col-lg-3 col-md-3 col-sm-12': true,
              'fix-wrap-mobile-css': true,
            }"
            v-if="
              footerComponent.securityImages &&
              footerComponent.securityImages.length > 0
            "
          >
            <nav class="menu-col footer-mnu security-section">
              <div class="menu-header">
                <span
                  :class="{
                    'custom-font-1 span-h4': true,
                    'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                    'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                  }"
                >
                  {{ $root.i18n.security }}
                </span>
              </div>
              <div class="footer-icons">
                <span
                  v-for="(imgData, index) in footerComponent.securityImages"
                  :key="index"
                >
                  <a
                    :title="
                    imgData.tooltip ? imgData.tooltip : getAltText(imgData.alt_text, imgData.image)"
                    v-if="
                      imgData.link && imgData.link != '' && imgData.link != ' '
                    "
                    :href="imgData.link"
                    target="_blank"
                    :rel="imgData.rel"
                  >
                    <img
                      :class="{
                        'legal-icon': true,
                        'grayscale-invert': getContrastYIQ(
                          $root.color_schema.footer_bg
                        ),
                      }"
                      width="78"
                      height="32"
                      :src="imgData.image"
                      :alt="getAltText(imgData.alt_text, imgData.image)"
                    />
                  </a>
                  <img
                    v-else
                    :class="{
                      'legal-icon': true,
                      'grayscale-invert': getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    width="78"
                    height="32"
                    :src="imgData.image"
                    :alt="`security image ${index + 1}`"
                  />
                </span>
              </div>
            </nav>
            <!--<div
              :class="{
                'ace-imgs': true,
                'fill-gray': getContrastYIQ($root.color_schema.footer_bg),
              }"
            >
              <svg viewBox="0 0 24 24">
                <path
                  d="M6.14392 24.0002H17.9279L12.0239 16.5122L6.14392 24.0002Z"
                />
                <path
                  d="M18.312 7.896C17.832 7.896 17.376 7.944 16.944 8.064C17.304 7.32 17.496 6.504 17.496 5.64C17.472 2.52 14.952 0 11.832 0C8.712 0 6.192 2.52 6.192 5.64C6.192 6.48 6.384 7.272 6.696 7.992C6.36 7.92 6 7.896 5.64 7.896C2.52 7.896 0 10.416 0 13.536C0 16.656 2.52 19.2 5.64 19.2C8.76 19.2 11.28 16.68 11.28 13.56C11.28 12.72 11.088 11.928 10.776 11.208C11.112 11.28 11.472 11.304 11.832 11.304C12.312 11.304 12.768 11.256 13.2 11.136C12.84 11.88 12.648 12.696 12.648 13.56C12.648 16.68 15.168 19.2 18.288 19.2C21.408 19.2 23.928 16.68 23.928 13.56C23.952 10.416 21.432 7.896 18.312 7.896Z"
                />
              </svg>
              <svg viewBox="0 0 19 24">
                <path d="M9.48 0L0 12L9.48 24L18.936 12L9.48 0Z" />
              </svg>
              <svg viewBox="0 0 24 22">
                <path
                  d="M21.9415 2.03431C19.2291 -0.678103 14.8214 -0.678103 12.0848 2.03431C12.0605 2.05853 12.0121 2.10696 11.9879 2.13118C11.9637 2.10696 11.9152 2.05853 11.891 2.03431C9.17861 -0.678103 4.77094 -0.678103 2.03431 2.03431C-0.678103 4.74672 -0.678103 9.17861 2.03431 11.891C2.05853 11.9152 2.10696 11.9637 2.13118 11.9879L11.9879 21.8446L21.8446 11.9879C21.8688 11.9637 21.9173 11.9152 21.9415 11.891C24.6781 9.17861 24.6781 4.77094 21.9415 2.03431Z"
                />
              </svg>
              <svg viewBox="0 0 20 24">
                <path
                  d="M3.86389 24.0001H15.6479L9.74389 16.5361L3.86389 24.0001Z"
                />
                <path
                  d="M17.856 8.088C17.832 8.064 17.808 8.04 17.784 8.016L9.744 0L1.728 8.016C1.704 8.04 1.68 8.064 1.656 8.088C-0.552 10.296 -0.552 13.896 1.656 16.104C3.864 18.312 7.464 18.312 9.672 16.104C9.696 16.08 9.72 16.056 9.744 16.032C9.768 16.056 9.792 16.08 9.816 16.104C12.024 18.312 15.624 18.312 17.832 16.104C20.064 13.896 20.064 10.296 17.856 8.088Z"
                />
              </svg>
            </div>-->
            <div class="mob-foot-show">
              <div
                class="social-icons"
                v-if="
                  footerComponent.socialIcons &&
                  Object.keys(footerComponent.socialIcons).length > 0
                "
              >
                <template
                  v-for="(iconData, index) in footerComponent.socialIcons"
                >
                  <p :key="index">
                    <a
                      :title="`social image ${index + 1}`"
                      v-if="
                        iconData.link &&
                        iconData.link != '' &&
                        iconData.link != ' '
                      "
                      :href="iconData.link"
                      target="_blank"
                      :rel="iconData.rel"
                    >
                      <img
                        :class="{
                          'grayscale-invert': getContrastYIQ(
                            $root.color_schema.footer_bg
                          ),
                        }"
                        width="18"
                        height="18"
                        :src="iconData.icon"
                        :alt="`social image ${index + 1}`"
                      />
                    </a>
                    <img
                      v-else
                      :class="{
                        'grayscale-invert': getContrastYIQ(
                          $root.color_schema.footer_bg
                        ),
                      }"
                      width="18"
                      height="18"
                      :src="iconData.icon"
                      :alt="`social image ${index + 1}`"
                    />
                  </p>
                </template>
              </div>

              <div class="disclaimer" v-html="footerComponent.disclaimer" v-if="footerComponent.disclaimer"></div>

              <p
                :class="{
                  'copyright-nt custom-font-2': true,
                  'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                  'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                }"
                v-if="footerComponent.footer_text2"
                v-html="footerComponent.footer_text2"
              ></p>
              <p
                :class="{
                  'copyright custom-font-2': true,
                  'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                  'text-light': !getContrastYIQ($root.color_schema.footer_bg),
                }"
                v-if="footerComponent.copyright_text"
                v-html="footerComponent.copyright_text"
              ></p>
            </div>
          </div>
          <div class="col-xs-12 desk-foot-show" v-if="footerComponent.disclaimer">
            <div class="disclaimer" v-html="footerComponent.disclaimer"></div>
          </div>
          <div class="col-lg-12 ptf-20 desk-foot-show">
            <p
              :class="{
                'copyright custom-font-2': true,
                'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                'text-light': !getContrastYIQ($root.color_schema.footer_bg),
              }"
              v-if="footerComponent.copyright_text"
              v-html="footerComponent.copyright_text"
            ></p>
            <p
              :class="{
                'copyright-nt custom-font-2': true,
                'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                'text-light': !getContrastYIQ($root.color_schema.footer_bg),
              }"
              v-if="footerComponent.footer_text2"
              v-html="footerComponent.footer_text2"
            ></p>
            <span
              :class="{
                'copyright-nt custom-font-2': true,
                'text-gray': getContrastYIQ($root.color_schema.footer_bg),
                'text-light': !getContrastYIQ($root.color_schema.footer_bg),
              }"
              v-else
              >&nbsp;</span
            >
            <div
              class="social-icons"
              v-if="
                footerComponent.socialIcons &&
                Object.keys(footerComponent.socialIcons).length > 0
              "
            >
              <template
                v-for="(iconData, index) in footerComponent.socialIcons"
              >
                <p :key="index">
                  <a
                    :title="`social image ${index + 1}`"
                    v-if="
                      iconData.link &&
                      iconData.link != '' &&
                      iconData.link != ' '
                    "
                    :href="iconData.link"
                    target="_blank"
                    :rel="iconData.rel"
                  >
                    <img
                      :class="{
                        'grayscale-invert': getContrastYIQ(
                          $root.color_schema.footer_bg
                        ),
                      }"
                      width="18"
                      height="18"
                      :src="iconData.icon"
                      :alt="`social image ${index + 1}`"
                    />
                  </a>
                  <img
                    v-else
                    :class="{
                      'grayscale-invert': getContrastYIQ(
                        $root.color_schema.footer_bg
                      ),
                    }"
                    width="18"
                    height="18"
                    :src="iconData.icon"
                    :alt="`social image ${index + 1}`"
                  />
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { slideUp, slideDown } from "@/misc/slide-up-down";
import { getContrastYIQ } from "@/misc/misc-function";

import NavMenu from "@/components/ui/NavMenu";

export default {
  name: "Footer",
  components: {
    NavMenu,
  },
  data: function () {
    return {
      selectedMenu: null,
    };
  },
  props: {
    footerComponent: {
      footerMenuTitle1: {
        type: String,
        default: () => "",
      },
      footerMenuTitle2: {
        type: String,
        default: () => "",
      },
      footerMenuTitle3: {
        type: String,
        default: () => "",
      },
      footerMenu1: {
        type: Array,
        default: () => [],
      },
      footerMenu2: {
        type: Array,
        default: () => [],
      },
      footerMenu3: {
        type: Array,
        default: () => [],
      },
      copyright_text: {
        type: String,
        default: () => "",
      },
      securityImages: {
        type: Array,
        default: () => [],
      },
      footerMenuCount1: {
        type: String,
        default: () => "",
      },
      footerMenuOffset1: {
        type: String,
        default: () => "",
      },
      footerMenuText1: {
        type: String,
        default: () => "",
      },
      footerMenuLink1: {
        type: String,
        default: () => "",
      },
      footerMenuCount2: {
        type: String,
        default: () => "",
      },
      footerMenuOffset2: {
        type: String,
        default: () => "",
      },
      footerMenuText2: {
        type: String,
        default: () => "",
      },
      footerMenuLink2: {
        type: String,
        default: () => "",
      },
      footerMenuCount3: {
        type: String,
        default: () => "",
      },
      footerMenuOffset3: {
        type: String,
        default: () => "",
      },
      footerMenuText3: {
        type: String,
        default: () => "",
      },
      footerMenuLink3: {
        type: String,
        default: () => "",
      },
      disclaimer: {
        type: String,
        default: ""
      }
    },
  },
  methods: {
    getContrastYIQ,
    expandFooterMenu: function (index) {
      let element = document.getElementById("footer-content-" + index);
      let icon = document.getElementById("footer-icon-" + index);
      if (this.selectedMenu === index) {
        this.selectedMenu = null;
        icon.classList.remove("rotate-180");
        slideUp(element, {
          duration: 100,
        });
      } else {
        this.selectedMenu = index;
        icon.classList.add("rotate-180");
        slideDown(element, {
          duration: 100,
        });
      }
    },
    getRoutePath: function (slug, type) {
      if (slug === "home") {
        return "/";
      } else if (
        type != "page" &&
        type != "post" &&
        type != "review" &&
        type != ""
      ) {
        return `/${type}/${slug}`;
      } else {
        return `/${slug}`;
      }
    },
  },
  watch: {
    selectedMenu: function (currVal, prevVal) {
      if (prevVal != null) {
        let element = document.getElementById("footer-content-" + prevVal);
        let icon = document.getElementById("footer-icon-" + prevVal);
        icon.classList.remove("rotate-180");
        slideUp(element, {
          duration: 300,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.rotate-180 {
  transform: rotate(180deg) !important;
}

.ct {
  &-footer {
    &-top {
      background: #070438;
      padding: 0 0 30px 0;
      @media (min-width: @sizes[tablet]) {
        padding: 45px 0;
      }
      .row {
        .col-lg-3 {
          width: 100%;
          @media (min-width: @sizes[large]) {
            width: 23%;
          }
          &:last-child {
            width: 100%;
            @media (min-width: @sizes[large]) {
              width: 31%;
            }
            .footer-mnu {
              border-bottom: none;
            }
          }
        }
      }
    }
    &-bottom {
      background: @dark-blue;
      padding: 20px;
      p {
        &.copy-right {
          color: @white;
          margin: 0;
        }
      }
    }
    .menu-col {
      .span-h4 {
        color: @white;
        font-weight: 700;
        margin-bottom: 0;
        @media (max-width: @sizes[small]) {
          display: block;
          margin: 0 auto;
        }
      }
      ul.footer-menu {
        padding-bottom: 0px;
        @media (max-width: @sizes[small]) {
          text-align: center;
        }
        // @media (min-width: @sizes[large]) {
        //   padding-bottom: 0px;
        // }
        li {
          margin: 7px 0;
          line-height: 1.4;
          &:first-child {
            margin: 0 0 5px;
          }
          a {
            color: @fadedgray;
            font-size: 16px;
            display: inline-block;
            &:hover,
            &:focus {
              color: @white;
            }
          }
        }
        &.two-columns {
          // column-count: 2;
        }
        &.disclaimer {
          margin-top: 25px;
          li {
            a {
              color: @mel-rose;
              &:hover,
              &:focus {
                color: @black;
              }
            }
          }
        }
      }
    }
    .footer-legal {
      .display-flex();
      .align-items(center);
      .justify-content-space-around();
      .flex-direction-column();
      .legal-icon {
        display: block;
        &:first-child {
          margin-bottom: 80px;
        }
        img {
          max-height: 75px;
          max-width: 145px;
        }
      }
    }
    .info {
      hr {
        border: none;
        height: 1px;
        background: @purple;
      }
      p {
        color: @mel-rose;
        margin: 0;
      }
    }
  }
}

.legal-icon {
  //margin-right: 13px;
  margin-bottom: 20px;
  display: inline-block;
}

.copyright {
  color: @white;
  font-size: 14px;
  position: relative;
  bottom: 0;
  margin: 15px 0 5px;
  @media (min-width: @sizes[large]) {
    width: 35%;
    float: left;
  }
  @media (min-width: @sizes[large]) {
    margin: 0;
  }
}

.copyright-nt {
  color: @white;
  font-size: 14px;
  position: relative;
  bottom: 0;
  margin: 0;
  @media (min-width: @sizes[large]) {
    width: 51%;
    float: left;
    text-align: right;
  }
}

.footer-menu {
  display: none;
  padding-top: 13px;
  @media (min-width: @sizes[large]) {
    display: block;
    padding-top: 0;
  }
}

.footer-menu-open {
  display: block;
}

.footer-mnu {
  border-bottom: 1px solid #5d5d5d;
  padding: 17px 0 8px;
  @media (min-width: @sizes[large]) {
    border-bottom: none;
    padding: 0;
  }
}

.menu-header {
  .display-flex();
  .align-items(center);
  .justify-content-space-between();
  margin-bottom: 0;
  pointer-events: auto;
  @media (min-width: @sizes[large]) {
    pointer-events: none;
    margin-bottom: 10px;
  }
  img {
    vertical-align: middle;
    display: block;
    width: 15px;
    @media (min-width: @sizes[large]) {
      display: none;
    }
  }
}

.img-rotate {
  transform: rotate(0deg);
  transition: 0.3s;
}

.img-rotate2 {
  transform: rotate(180deg);
  transition: 0.3s;
}

.footer-icons {
  margin-top: 13px;
  @media (max-width: 767px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
  @media (min-width: @sizes[large]) {
    margin-top: 0;
    margin-right: -12px;
  }
  span {
    //margin-right: 15px;
    @media (min-width: 375px) {
      //margin-right: 6px;
    }
    @media (min-width: 425px) {
      //margin-right: 18px;
    }
    @media (min-width: @sizes[medium]) {
      margin-right: 20px;
    }
    img {
      width: 78px;
      @media (min-width: 375px) {
        width: 85px;
      }
      @media (min-width: 425px) {
        width: 97px;
      }
      @media (min-width: @sizes[medium]) {
        width: 78px;
      }
    }
  }
}

.social-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  @media (max-width: @sizes[large]) {
    justify-content: space-evenly;
    padding: 15px 0;
    border-top: 1px solid #5d5d5d;
    border-bottom: 1px solid #5d5d5d;
    margin-bottom: 15px;
  }
  @media (min-width: @sizes[large]) {
    width: 14%;
    float: left;
  }
  p {
    display: flex;
    flex-wrap: wrap;
    width: 18px;
    height: 18px;
    margin-left: 13px;
    margin-bottom: 3px;
    @media (max-width: @sizes[large]) {
      width: 24px;
      height: 24px;
    }
    img {
      width: 18px;
      height: 18px;
      @media (max-width: @sizes[large]) {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.router-link-active {
  color: #e3e3e3 !important;
}

.grayscale-invert {
  filter: grayscale(1) invert(1);
  -webkit-filter: grayscale(1) invert(1);
}

.security-section {
  padding-top: 17px;
  @media (min-width: @sizes[large]) {
    padding-top: 0px;
  }
}

.ace-imgs {
  display: flex;
  @media (max-width: @sizes[large]) {
    justify-content: center;
    padding: 10px 0;
  }
  svg {
    width: 20px;
    height: 25px;
    margin-right: 25px;
    fill: @fadedgray;
  }
}

.fill-gray {
  svg {
    fill: @black;
  }
}

.ptf-20 {
  padding-top: 20px !important;
}

.mob-foot-show {
  display: block;
  text-align: center;
  @media (min-width: @sizes[large]) {
    display: none;
  }
}

.desk-foot-show {
  display: none;
  @media (min-width: @sizes[large]) {
    display: block;
  }
}

.overlap-width {
  @media (min-width: @sizes[large]) {
    width: 31% !important;
    display: flex;
  }
}

.fix-wrap-mobile-css {
   @media (max-width: @sizes[large]) {
    text-align: center;
    float: left;
  }
}

.mob-foot-show .copyright-nt {
  padding-top: 20px;
}
</style>
<style>
.disclaimer {
  padding-top: 20px;
}

.disclaimer p {
  font-size: 12px;
  color: #F0F0F0;
}

.disclaimer p:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/Footer.vue